module.exports = __webpack_public_path__ + "static/media/majorD7.8737888.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorD7.wav
// module id = ULqa
// module chunks = 0